<script>
/** Utilities */
import {mapState,mapMutations} from 'vuex'
import ArrayUtil from '../../utilities/ArrayUtil';
import AppResourceUtil from '../../utilities/AppResourceUtil'
/** APIs */
import UserApi from '../../api/UserApi'
import IssueApi from '../../api/IssueApi'
import FormsApi from '../../api/FormsApi'
import ValidationCardApi from '../../api/ValidationCardApi'
import ValidationPeriodApi from '../../api/ValidationPeriodApi'
/** Constants */
import { FormsData, LookupInputTypes } from '../../constants/FormsData'
import ReportingGroup from '../../constants/ReportingGroup'
/** UI Components */
import { Collapse } from 'buefy/dist/components/collapse'
import { Checkbox } from 'buefy/dist/components/checkbox'
import { Dropdown, DropdownItem } from 'buefy/dist/components/dropdown'
import { Field } from 'buefy/dist/components/field'
import { Icon } from 'buefy/dist/components/icon'
import { Input } from 'buefy/dist/components/input'
import { Loading } from 'buefy/dist/components/loading'
import { Modal } from 'buefy/dist/components/modal'
import { Select } from 'buefy/dist/components/select'
import { Table,TableColumn } from 'buefy/dist/components/table'
import { Tabs,TabItem } from 'buefy/dist/components/tabs'
import { Message } from 'buefy/dist/components/message'

const VPERIOD_READY_STATUS = 'Ready';
const VPERIOD_OPEN_STATUS = 'Open';
const VPERIOD_CLOSED_STATUS = 'Closed';

export default {
    name : "FormsView",
    components: {
        'b-checkbox' : Checkbox,
        'b-collapse' : Collapse,
		'b-dropdown' : Dropdown,
        'b-dropdown-item' : DropdownItem,		
        'b-field' : Field,
        'b-icon' : Icon,
        'b-input' : Input,
        'b-loading' : Loading,
        'b-modal' : Modal,
        'b-select' : Select,
        'b-table' : Table,
        'b-table-column' : TableColumn,
        'b-tabs' : Tabs,
        'b-tab-item' : TabItem,
        'b-message' : Message
    },
    computed : {
        ...mapState({
            allForms : "allFormsData",
            profile : "userProfile",
            token : "xOreAuth"
        }),
        filteredForms(){
            var searchKeyword = this.searchKeyword;
            var searchExp = new RegExp(searchKeyword,"i");
            if (searchKeyword.length > 3) {
                return this.allForms.filter(form=>{
                    return (form.formName.match(searchExp))
                })
            }
            return this.allForms;
        },
        vperiodOpen() {
            if (this.validationPeriod) {
                if (this.validationPeriod.vPeriodStatus === VPERIOD_OPEN_STATUS) {
                    return true
                }
            }
            return false
        },
        vperiodReady() {
            if (this.validationPeriod) {
                if (this.validationPeriod.vPeriodStatus === VPERIOD_READY_STATUS) {
                    return true
                }
                return false
            }
            return true
        },
        vperiodClosed() {
            if (this.validationPeriod) {
                if (this.validationPeriod.vPeriodStatus === VPERIOD_CLOSED_STATUS) {
                    return true
                }
            }
            return false
        },
        heightClass () {
            if (!this.vperiodReady) {
                return 'app-view--min'
            }
            return 'app-view--sm'
        }
    },
    data(){
        return {
            activeStep : 0,
            // allForms : [],
            groupBy : "All",
            draggingRow : null,
            draggingRowIndex : null,
            defaultOpenedDetails: [],
            inputTypesLov : LookupInputTypes,
            newFormData : {},
            openAddModal: false,
            openFieldMgtModal : false,
            proceedToFields : false,
            reportingGroupsLov : ReportingGroup,
            searchKeyword : "",
            selectedForm : null,
            isLoading : false,
            isFullPage : false,
            selectedReportingYear : null,
            reportingYearLov : [],
            validationPeriod: null
        }
    },
    created(){
        if (!this.profile) {
            this.clearSession();
            return false;
        }
        this.isTokenValid();
    },
    methods: {
        ...mapMutations({
            clearAppData : "clearAppData",
            setAllFormsData: "updateAllFormsData",
            updateFormData: 'updateFormData'
        }),
        isTokenValid(){
            if (!this.token) {
                this.clearSession();
                return false
            }
            UserApi.isTokenValid({
                token : this.token
            })
            .then(response=>{
                if (response.data){
                    if (response.data.length > 0) {
                        let data = response.data[0];
                        if (data.dateCreated) {
                            let a = this.$moment();
                            let b = this.$moment(data.dateCreated,'YYYY-MM-DD HH:mm:ss');
                            let duration = a.diff(b, 'days');
                            if (duration >= 1 ) {
                                // Session is expired
                                this.logOut()
                            }
                            else {
                                // Session is still active
                                // Default call in created
                                // if (this.allForms.length==0) {
                                    this.getReportingYearLov();
                                    // get forms
                                // }
                            }
                        }
                    }
                    else {
                        if (response.data.hasOwnProperty('error')) {
                            this.promptServerError({response},'User.isSessionValid');
                            return false;
                        }
                        this.logOut();
                        return false;
                    }
                } 
            })
            .catch(error=>{
                this.promptServerError(error,'User.isSessionValid');
            });
        },
        logOut(){   
            if (this.token) {
                let data = {
                    token : this.token
                }
                if (this.profile) {
                    data.userIdFk = this.profile.userId
                }
                // End session from back-end
                UserApi.endSession(data)
                .then(response=>{
                    if (response.data) {
                        if (response.data.isDeleted) {
                            this.clearSession();
                        }
                    }
                })
                .catch(error=>{
                })
            }
            else {
                // Remove session data from client-side
                this.clearSession();
            }
        },
        clearSession(){
            BrowserDataUtil.clearBrowserData(this.$cookies);
            this.clearAppData();
            this.$router.push({path:"/login"})
        },
        getReportingYearLov(){
            this.setAllFormsData([]);
            this.isLoading = true;
            this.reportingYearLov = [];
            this.selectedReportingYear = null;
            
            let staticYrs = AppResourceUtil.getRepYrStaticLov();
            // Default reporting year is current year minus 1; or previous year
            let defaultRepYear = parseInt(this.$moment().format('YYYY'),10) - 1;

            ValidationCardApi.getReportingYearLov()
            .then(response=>{
                let repYearInDb = [];
                if (response.data) {
                    if (!response.data.error) {

                        if (response.data.length > 0) {
                            repYearInDb = response.data.map(yr=>{
                                return (yr.reportingYear);
                            });
                        }
                        
                        /* Merge static years and rep year found in the database */ 
                        let allRepYrsLov = this.$_.union(staticYrs,repYearInDb);

                        /* Sort the years in descending order */ 
                        this.reportingYearLov = allRepYrsLov.sort().reverse();

                        if (this.$route.query) {
                            try {
                                if (this.$route.query.reportingYear) {
                                    this.selectedReportingYear = parseInt(this.$route.query.reportingYear,10);
                                }
                            }
                            catch(repYrErr){}
                        }
                        
                        if (!this.selectedReportingYear) {
                            if (repYearInDb > 0) {
                                try {
                                    /* Pre-select the year with data (from DB) */ 
                                    this.selectedReportingYear = repYearInDb[0];
                                }
                                catch(yrErr){}
                            }
                            else {
                                this.selectedReportingYear = defaultRepYear;
                            }
                        }

                        if (this.selectedReportingYear != null) {
                            this.getValidationPeriod(this.selectedReportingYear)
                            // if (this.allForms.length==0) {
                                this.getForms();
                            // }
                            // else {
                            //     this.isLoading = false;
                            // }
                        }
                        else {
                            this.isLoading = false;
                        }
                    }
                    else {
                        this.isLoading = false;
                        this.promptServerError({response},'ValidationCard.getReportingYearLov');
                    }
                }
                
            })
            .catch(error=>{
                this.isLoading = false;
                this.promptServerError(error,'ValidationCard.getReportingYearLov');
            });
        },
        getValidationPeriod(formYear){
            this.validationPeriod = null;
            ValidationPeriodApi.get({
                reportingYear : formYear,
                status : ''
            })
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        if (response.data.length == 0) {
                            // No validation period
                        }
                        else {
                            if (response.data[0]) {
                                this.validationPeriod  = response.data[0];
                            }  
                        }
                    } 
                    else {
                        this.promptServerError({response},'ValidationPeriod.get');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'ValidationPeriod.get');
            })
        },
        getForms(){
            // With back-end integration
            // this.allForms = []; 
            this.isLoading = true;
            
            let data = null;
            if (this.selectedReportingYear!=null) {
                data = { 
                    reportingYear : this.selectedReportingYear 
                };
            }

            FormsApi.getAll(data)
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        let forms = response.data;
                        forms.forEach(form=>{
                            let entAccess = [], unitAccess = [];
                            if (form.formAccessData.reportingEntities.length > 0) {
                                entAccess = form.formAccessData.reportingEntities.filter(ent=>{
                                    return ent.isArchived === 0
                                }).map(ent=>{
                                    return ent.reportingEntity
                                })
                            }
                            if (form.formAccessData.reportingUnits.length > 0) {                                
                                unitAccess = form.formAccessData.reportingUnits.filter(unt=>{
                                    return unt.isArchived === 0
                                }).map(unt=>{
                                    return unt.reportingUnit
                                })
                            }
                            form.formAccessDataNameList = this.$_.union(entAccess,unitAccess);
                            form.formAccessDataStr = form.formAccessDataNameList.join(",");
                            /** Convert Date */
                            form.dateCreated = AppResourceUtil.convertDate(form.dateCreated)
                            form.dateLastUpdated = AppResourceUtil.convertDate(form.dateLastUpdated)
                            form.datePublished = AppResourceUtil.convertDate(form.datePublished)
                        });
                        // this.allForms = forms;
                        
                        // set store data - forms
                        this.setAllFormsData(forms);
                        this.isLoading = false;
                    }
                    else {
                        this.isLoading = false;
                        this.promptServerError({response},'Form.getAll');
                    }
                }
            })
            .catch(error=>{
                this.isLoading = false;
                this.promptServerError(error,'Form.getAll');
            });
        },
        selectReportingYear(){
            this.getValidationPeriod(this.selectedReportingYear)
            this.getForms();
        },
        dragStart(payload){
            this.draggingRow = payload.row;
            this.draggingRowIndex = payload.index;
            payload.event.dataTransfer.effectAllowed = "copy";
        },
        dragOver(payload){
            payload.event.dataTransfer.dropEffect = "copy";
            payload.event.target.closest('tr').classList.add('is-selected');
            payload.event.preventDefault()
        },
        doDrop(payload){

            payload.event.target.closest('tr').classList.remove('is-selected');
            const droppedOnRowIndex = payload.index;

            let tempDraggedRow = this.allForms[this.draggingRowIndex];
            let tempDroppedRow = this.allForms[droppedOnRowIndex];

            var newForms = [];
            if ( (droppedOnRowIndex-this.draggingRowIndex)==1 ) {
                // Swap
                for (var idx=0;idx<this.allForms.length;idx++) {
                    if (idx==this.draggingRowIndex) {
                        newForms.push(tempDroppedRow);
                    }
                    else if (idx==droppedOnRowIndex) {
                        newForms.push(tempDraggedRow);
                    }
                    else {
                        newForms.push(this.allForms[idx]);
                    }
                }
            }
            else {
                for (var idx=0;idx<this.allForms.length;idx++) {
                    if (idx<droppedOnRowIndex && idx!==this.draggingRowIndex && idx!==droppedOnRowIndex) {
                        newForms.push(this.allForms[idx]);
                    }
                    else if (idx==droppedOnRowIndex) {
                        newForms.push(tempDraggedRow);
                        newForms.push(tempDroppedRow);
                    }
                    else if (idx!==this.draggingRowIndex && idx!==droppedOnRowIndex) {
                        newForms.push(this.allForms[idx]);
                    }
                }
            }
            // Set new sequnce numbers
            newForms.forEach((form,idx)=>{
                form.tempSequenceNumber = idx 
            });
            // Do save new sequence numbers
            this.updateFormSequence(newForms);
        },
        dragLeave(payload){
            payload.event.target.closest('tr').classList.remove('is-selected')
            payload.event.preventDefault()
        },
        updateFormSequence(newForms){
            FormsApi.reorder({
                forms: newForms,
                updatedBy : this.profile.userId
            })
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        if (response.data.isUpdated) {
                            this.allForms = newForms;
                        }
                    }
                    else {
                        this.promptServerError({response},'Form.reorder');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'Form.reorder');
            })
        },
        toggleRow(row,ref) {
            this.$refs[ref].toggleDetails(row);
        },
        openManageFields(row){
            this.$router.push({path:"/admin/forms/"+row.formId+'/edit?step=2&reportingYear='+row.reportingYear});
        },
        openEditForm(row) {
            this.$router.push({path:"/admin/forms/"+row.formId+'/edit?reportingYear='+row.reportingYear});
        },
        openCopyForm(row) {
            if (this.validationPeriod && this.validationPeriod.reportingYear === row.reportingYear) {
                var msg = ''
                if (this.vperiodClosed) {
                    msg = ' closed'
                }
                if (this.vperiodOpen) {
                    msg = ' open'
                }
                if (msg !== '') {
                    this.$dialog.prompt({
                        message: `<strong>${row.formName}</strong> is created for ${row.reportingYear} reporting year, which is already in status <strong class="is-uppercase">${msg}</strong>. Please choose a new reporting year for this form copy.`,
                        inputAttrs: {
                            type: 'number',
                            placeholder: 'Enter reporting year',
                            value: row.reportingYear + 1,
                            maxlength: 4,
                            min: row.reportingYear + 1,
                            max: row.reportingYear + 2
                        },
                        trapFocus: true,
                        onConfirm: (value) => {
                            if (value === row.reportingYear) {
                                this.$notification.open({
                                    duration: 5000,
                                    message: 'Please assign a new reporting year.',
                                    position: 'is-bottom-left',
                                    type: 'is-danger'
                                });
                                return false
                            }
                            this.$router.push({path:`/admin/forms/${row.formId}/copy?reportingYear=${row.reportingYear}&newReportingYear=${value}`})
                        }
                    })
                } else {
                    this.$router.push({path:`/admin/forms/${row.formId}/copy?reportingYear=${row.reportingYear}&newReportingYear=${row.reportingYear}`})
                }
            }
        },
        confirmUnpublish(row){
            // Check if there validation forms mapped to this form
            // If yes, restrict unpublish
            // otherwise, proceed
            this.$dialog.confirm({
                title: 'Unpublish Confirmation',
                message: 'This form will no longer be shown for non-admin users. What do you want to do?',
                cancelText: "Don't Unpublish",
                confirmText: 'Unpublish',
                type: 'is-danger',
                onConfirm: () => {
                    this.publish(row,'unpublish')
                }
            });
        },
        publish(form,action) {
            FormsApi.publish({
                formId : form.formId,
                action : action,
                updatedBy : this.profile.userId
            })
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        var data = response.data;
                        if (data.isUpdated==true) {
                            if (action=='publish') {
                                this.$notification.open({
                                    duration: 5000,
                                    message: 'Form published.',
                                    position: 'is-bottom-left',
                                    type: 'is-success'
                                });
                            }
                            else {
                                this.$notification.open({
                                    duration: 5000,
                                    message: 'Form unpublished.',
                                    position: 'is-bottom-left',
                                    type: 'is-success'
                                });
                            }
                            /** Non-store implementation */
                            // this.getForms();
                            this.getOne(form.formId)
                        }
                    }
                    else {
                        this.promptServerError({response},'Form.publish');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'Form.publish');
            });
        },
        getOne(formId) {
            FormsApi.getOne(formId)
            .then(response=>{
                if (response.data) {
                    if (!response.data.error){
                        let form = response.data;
                        /** Convert date */
                        form.dateLastUpdated = AppResourceUtil.convertDate(form.dateLastUpdated)
                        form.datePublished = AppResourceUtil.convertDate(form.datePublished)
                        this.updateFormData(form)
                    }
                    else {
                        this.promptServerError({response},'Form.getOne');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'Form.getOne');
            });
        },
        confirmDelete(row){
            // Check if form is published
            // and if there are validation forms attached to it,
            if (row.isPublished==true) {
                this.$dialog.alert({
                    title: 'Error',
                    message: 'This form is already published. Delete is not allowed.',
                    type: 'is-danger',
                    hasIcon: true,
                    icon: 'times-circle',
                    iconPack: 'fa'
                })
                return false;
            }
            this.$dialog.confirm({
                title: 'Delete Confirmation',
                message: 'Deleting this form cannot be undone. What do you want to do?',
                cancelText: "Don't Delete",
                confirmText: 'Delete',
                type: 'is-danger',
                onConfirm: () => {
                    this.delete(row.formId)
                }
            });
        },
        delete(formId) {
            FormsApi.delete(formId)
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        var data = response.data;
                        if (data.isDeleted==true) {

                            this.$notification.open({
                                duration: 5000,
                                message: 'Form deleted.',
                                position: 'is-bottom-left',
                                type: 'is-success'
                            });
                            
                            this.getForms();
                        }
                        else {
                            this.$notification.open({
                                duration: 5000,
                                message: 'An error occurred on delete.',
                                position: 'is-bottom-left',
                                type: 'is-danger'
                            });
                        }
                    }
                    else {
                        this.promptServerError({response},'Form.delete');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'Form.delete');
            });
        },
        showAccessList(form) {
            let accessListStr = "";
            if (form.formAccessDataNameList.length > 0) {
                form.formAccessDataNameList.forEach(name=>{
                    accessListStr += '<li style="list-style-type:disc;margin-left:1.75em;">'+name+'</li>';
                });
            }
            this.$dialog.alert({
                title: 'Form access ('+form.formName+')',
                message: '<p><ul>'+accessListStr+'</ul></p>',
                type: 'is-info'
            });
        },
        submitError(errorData,api){   
            let obj = {
                email : this.profile.email,
                username : this.profile.username,
                message : "["+errorData.type+" "+errorData.code+"] - "+errorData.message+" Request to: "+api,
                issueStatus : "Pending",
                issueType : "Issue",
                createdBy : this.profile.userId,
                pageName : this.$route.name,
                pageLink : this.$route.path
            };

            if (errorData.hasOwnProperty('query')) {
                obj.message += ' SQL Query: '+errorData.query;
            }

            // Add feedback/issue to DB
            IssueApi.add(obj)
            .then(response=>{
                if (response.data) {
                    if (response.data.issueId) {
                        this.$dialog.alert({
                            title: 'Success',
                            message: "<p><strong>Thanks for reporting!</strong></p><br/>  Admin will check this and get back to you, if necessary.",
                            type: 'is-success'
                        });
                    }
                    else {
                        this.$dialog.alert({
                            title: 'Error',
                            message: "Unable to submit error. Please try again later.",
                            type: 'is-danger'
                        });
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'Issue.add');
            });
        },
        promptServerError(error,api){
            try {
                let returnData = AppResourceUtil.getErrorData(error.response);
                if (returnData.errorData!=null) {
                    this.$dialog.confirm({
                        title: returnData.dialog.title,
                        message: returnData.dialog.message,
                        cancelText: "Close",
                        confirmText: "Submit Error",
                        type: 'is-danger',
                        onConfirm: () => {
                            this.submitError(returnData.errorData,api);
                        }
                    });
                }
            } 
            catch(respError){
                console.log(respError)
            }
        },
        refreshData(){
            this.getForms();
        }
    }
}
</script>

<template>
    <section>
        <p class="subtitle page-title">Forms</p>

        <b-message 
            type="is-danger"
            v-if="!vperiodReady"
            style="margin-left:1rem">
            Reporting period ({{selectedReportingYear}}) is in status <strong class="is-uppercase">{{validationPeriod.vPeriodStatus}}</strong>. 
            <br/>When a reporting period is in OPEN or CLOSED status, creating, updating, deleting, and grouping of forms for this reporting period are no longer allowed.
            <br/>To be able to do these tasks, go to <a href="/#/admin-dashboard">Dashboard</a> and move the reporting period status to 'Ready'.
        </b-message>

        <!-- Filter Options /Search -->
        <div class="columns"
            style="margin-left:1rem;">
            <div class="column is-narrow">
                <div class="field is-grouped">
                    <div class="control">
                        <b-dropdown
                            v-model="selectedReportingYear">
                            <button class="button is-primary is-outlined"
                                type="button"
                                slot="trigger">
                                <template
                                    v-if="selectedReportingYear">
                                    <strong>Reporting Year ({{selectedReportingYear}})</strong>
                                </template>
                                <template
                                    v-else>
                                    <strong>Select Reporting Year</strong>
                                </template>
                                <b-icon icon="menu-down"></b-icon>
                            </button>

                            <b-dropdown-item
                                v-for="(year,yearIdx) in reportingYearLov"
                                v-bind:key="yearIdx"
                                v-bind:value="year"
                                v-on:click="selectReportingYear(year)">
                                <h4>{{year}}</h4>
                            </b-dropdown-item>
                            
                        </b-dropdown>
                    </div>
                    <b-field>
                        <b-input placeholder="Search Form"
                            type="search"
                            icon="magnify"
                            v-model="searchKeyword">
                        </b-input>
                        <p class="control">
                            <button class="button is-info">Search</button>
                        </p>
                    </b-field>
                    <div class="control">
                        <button type="button"
                            class="button is-light tooltip is-tooltip-bottom"
                            data-tooltip="Refresh data"
                            v-on:click="refreshData">
                            <span class="icon">
                                <i class="fas fa-redo"></i>
                            </span>
                        </button>
                    </div>
                    <!-- <a s
                        class="button is-primary"
                        v-on:click="openAddForm"> -->
                    <!-- <div class="buttons">
                    </div> -->
                    <a 
                        v-if="selectedReportingYear && vperiodReady"
                        class="button is-primary"
                        v-bind:href="'#/admin/forms/add?reportingYear='+selectedReportingYear">
                        <span class="icon">
                            <i class="fas fa-plus"></i>
                        </span>
                        <span>Add Form</span>
                    </a>
                    &nbsp;&nbsp;
                    <a 
                        v-if="selectedReportingYear && vperiodReady"
                        class="button is-dark is-outlined"
                        v-bind:href="'#/admin/forms/group?reportingYear='+selectedReportingYear">
                        <!-- <span class="icon">
                            <i class="fas fa-plus"></i>
                        </span> -->
                        <span>Group Forms</span>
                    </a>
                </div>
            </div>
            <div class="column has-text-right">
            </div>
        </div>

        <section class="section no-padd--top app-view"
            :class="heightClass"> 
            
            <section class="base-box--loading"
                v-if="isLoading">
                <b-loading 
                    v-bind:is-full-page="isFullPage" 
                    v-bind:active.sync="isLoading"
                    >
                    <b-icon
                        pack="fas"
                        icon="sync-alt"
                        size="is-medium"
                        custom-class="fa-spin">
                    </b-icon>
                    &nbsp;&nbsp;&nbsp;
                    <span class="title is-5">Loading forms</span>
                </b-loading>
            </section>

            <section class="section no-padd--top form-table-section"
                v-if="!isLoading"> 
                <!-- <span class="is-italic has-text-info"
                    v-if="filteredForms.length > 0">*You may click & drag rows to reorder the forms.</span> -->
                <b-table
                    v-bind:data="(filteredForms.length == 0) ? [] : filteredForms"
                    ref="details-table"
                    v-bind:mobile-cards="true">
                    <!-- draggable
                    v-on:dragstart="dragStart"
                    v-on:drop="doDrop"
                    v-on:dragover="dragOver"
                    v-on:dragleave="dragLeave" -->
                    <!-- detailed
                    detail-key="formId"
                    v-bind:opened-detailed="defaultOpenedDetails"
                    v-bind:show-detail-icon="true"> -->
                    <!-- v-on:details-open="(row,index)=>expandRow(row,index)" -->
                    <template
                        slot-scope="props">

                        <b-table-column
                            field=""
                            label=""
                            width="50">
                            <b-dropdown>
                                <button type="button"
                                    class="button is-small is-light"
                                    slot="trigger"
                                    role="button">
                                    <span class="icon fa-sm">
                                        <i class="fas fa-ellipsis-v fa-lg"></i>
                                    </span>
                                </button>

                                <b-dropdown-item
                                    v-bind:disabled="props.row.isPublished==true || !vperiodReady"
                                    v-on:click="openEditForm(props.row)">
                                    <b-icon size="fa-sm" 
                                        pack="fas"
                                        icon="pen">
                                    </b-icon>
                                    Edit Form Details
                                </b-dropdown-item>

                                <b-dropdown-item
                                    v-bind:disabled="props.row.isPublished==true || !vperiodReady"
                                    v-on:click="openManageFields(props.row)">
                                    <b-icon size="fa-sm" 
                                        pack="fas"
                                        icon="plus">
                                    </b-icon>
                                    Manage Fields
                                </b-dropdown-item>

                                <b-dropdown-item
                                    v-on:click="openCopyForm(props.row)">
                                    <b-icon size="fa-sm" 
                                        pack="fas"
                                        icon="copy">
                                    </b-icon>
                                    Copy Form
                                </b-dropdown-item>

                                <!-- <b-dropdown-item>
                                    <b-icon size="fa-sm" 
                                        pack="fas"
                                        icon="copy">
                                    </b-icon>
                                    Duplicate Form
                                </b-dropdown-item> -->

                                <hr class="dropdown-divider">

                                <!-- <b-dropdown-item>
                                    <b-icon size="fa-sm" 
                                        pack="fas"
                                        icon="ban">
                                    </b-icon>
                                    {{props.row.isActive==true ? 'Deactivate' : 'Activate' }}
                                </b-dropdown-item> -->

                                <b-dropdown-item
                                    v-bind:disabled="props.row.isPublished==true || !vperiodReady"
                                    v-on:click="confirmDelete(props.row)">
                                    <b-icon size="fa-sm" 
                                        pack="fas"
                                        icon="trash">
                                    </b-icon>
                                    Delete permanently
                                </b-dropdown-item>

                            </b-dropdown>
                        </b-table-column>

                        <!-- <b-table-column
                            field="sequenceNumber"
                            label="Sequence Number">
                            {{props.row.sequenceNumber}} --
                            {{props.row.tempSequenceNumber}}
                        </b-table-column> -->

                        <b-table-column
                            field="formName"
                            label="Name">
                            <a class="button is-text"
                                v-bind:href="'#/admin/forms/'+props.row.formId+'/preview?reportingYear='+props.row.reportingYear">{{props.row.formName}}</a>
                        </b-table-column>

                        <b-table-column
                            field="reportingYear"
                            label="Reporting Year">
                            {{props.row.reportingYear}}
                        </b-table-column>

                        <b-table-column
                            field="formAccessData"
                            label="Access">

                            <div class="tags">
                                <span class="tag"
                                    v-for="(access,accessIdx) in props.row.formAccessData.reportingGroups"
                                    v-bind:key="accessIdx"
                                    v-bind:class="access.repGroupTagClass">
                                    {{access.reportingGroup}}
                                </span>
                                <a class="tag"
                                    v-if="props.row.formAccessDataNameList && props.row.formAccessDataNameList.length > 0"
                                    title="View Reporting Entities/Units"
                                    v-on:click="showAccessList(props.row)">
                                    <i class="fas fa-ellipsis-h fa-lg"></i>
                                </a>
                            </div>
                        </b-table-column>

                        <b-table-column
                            field="formFieldsCnt"
                            label="No. of Fields"
                            width="80"
                            centered>
                            <a class="button is-text"
                                v-if="vperiodReady"
                                v-on:click="openManageFields(props.row)">{{props.row.formFields.length}}</a>
                            <span class="is-text"
                                v-else>{{props.row.formFields.length}}</span>
                        </b-table-column>

                        <!-- <b-table-column
                            field="isActive"
                            label="Active"
                            centered>
                            {{props.row.isActive ? 'Yes' : 'No' }}
                        </b-table-column> -->

                        <b-table-column
                            field="isPublished"
                            label="Publish Option"
                            centered>
                            <div v-if="vperiodReady">
                                <a class="button is-link"
                                    type="button"
                                    v-if="props.row.isPublished==false"
                                    v-on:click="publish(props.row,'publish')">
                                    <span>
                                        <i class="fas fa-upload"></i>
                                    </span>&nbsp;
                                    <span>Publish</span>
                                </a>
                                <a class="button is-light"
                                    type="button"
                                    v-if="props.row.isPublished==true"
                                    v-on:click="confirmUnpublish(props.row)">
                                    <span>Unpublish</span>
                                </a>
                            </div>
                            <div v-else>
                                <div class="icon-text">
                                    <span 
                                        :class="props.row.isPublished ? 'icon' : 'icon has-text-grey'"
                                        :title="props.row.isPublished==true ? 'Form is published.': 'Form is not published.'">
                                        <i :class="props.row.isPublished ? 'far fa-eye' : 'fas fa-eye-slash'"></i>
                                    </span>
                                </div>
                            </div>
                        </b-table-column>

                        <b-table-column
                            label="Logs"
                            width="100"
                            centered>
                            <b-dropdown 
                                aria-role="list" 
                                position="is-bottom-left">
                                <button type="button"
                                    class="button is-small is-light"
                                    slot="trigger"
                                    role="button">
                                    <span class="icon fa-sm">
                                        <i class="fas fa-ellipsis-h fa-lg"></i>
                                    </span>
                                </button>
                                <b-dropdown-item aria-role="listitem">
                                    <div>
                                        <strong>Last updated by: </strong> {{props.row.lastUpdatedByName}}<br/>
                                        <strong>Last updated on: </strong> {{props.row.dateLastUpdated}}
                                    </div>
                                    <hr class="dropdown-divider">
                                    <div>
                                        <strong>Published by: </strong> {{props.row.publishedByName}}<br/>
                                        <strong>Last published on: </strong> {{props.row.datePublished}}
                                    </div>
                                    <hr class="dropdown-divider">
                                    <div>
                                        <strong>Created by: </strong> {{props.row.createdByName}}<br/>
                                        <strong>Date created: </strong> {{props.row.dateCreated}}
                                    </div>
                                </b-dropdown-item>
                            </b-dropdown>
                        </b-table-column>

                    </template>

                    <template slot="empty">
                        <section class="section">
                            <div class="content has-text-grey has-text-centered">
                                <p>No forms yet.</p>
                            </div>
                        </section>
                    </template>
                </b-table>
            </section>
            
        </section>

    </section>
</template>

<style scoped>
.form-box {
    border-radius: 0px;
    margin: 5px 1px;
}
.drag-list {
    display: block;
    height: 500px;
    border: 1px solid red;
}
.drag-item {
    padding: 1em;
}
.form-table-section {
    min-height: 35vh;
}

.form-table-section .is-divider {
    margin: 1.2rem;
}
.repgrp-tag-inline {
    margin-right: 0.3rem;
}
.fields-table {
    margin: auto;
    width: 98%;
    min-height: 400px;
    max-height: 450px;
    overflow-y: scroll;
    overflow-x:hidden;
    margin-top: 2rem;
    margin-bottom: 2rem;
}
.form-fields-box,
.new-form-box {
    padding:1.5rem;
}
.new-form-details-box {
    min-height: 400px;
}
.app-view--min {
	min-height: 30vh;
	max-height: 45vh;
	overflow:hidden;
	overflow-y:scroll;
}
.app-view--sm {
	min-height: 30vh;
	max-height: 65vh;
	overflow:hidden;
	overflow-y:scroll;
}
</style>




// WEBPACK FOOTER //
// src/views/administration/FormsView.vue